import Vue from "vue";
import organizationsService from "@/services/organizations.service";

export const organizations = {
  namespaced: true,
  state: {
    organizations: []
  },
  getters: {},
  actions: {
    async getOrganizations({ commit }) {
      try {
        const organizations = await organizationsService.getOrganizations();

        commit("setOrganizations", organizations);
      } catch (error) {
        Vue.noty.error(
          this.app.i18n.t("recurring_debit.messages.error_get_organizations")
        );
      }
    }
  },
  mutations: {
    setOrganizations(vuexState, payload) {
      vuexState.organizations = payload;
    }
  }
};
